import { addUtcDaysToToday } from "./assessmentDateUtils";

/** Matches AL Assessment Settings → Default due date option lists. */
export const ASSESSMENT_DUE_DATE_DAY_OPTIONS = [1, 3, 5, 7, 10, 14, 21, 30];

/** Formal due date: the ESL picks 30 to 60 days after launch. */
export const FORMAL_MIN_DUE_DAYS = 30;
export const FORMAL_MAX_DUE_DAYS = 60;
export const FORMAL_DUE_DATE_DAY_OPTIONS = [30, 45, 60];

export const DEFAULT_FORMAL_DUE_DATE_DAYS = 30;
export const DEFAULT_TEAM_DUE_DATE_DAYS = 14;
export const DEFAULT_DISCONNECT_DUE_DATE_DAYS = 7;

const resolveDueOption = (value: unknown, fallback: number): number => {
  const n = Number(value);
  return ASSESSMENT_DUE_DATE_DAY_OPTIONS.includes(n) ? n : fallback;
};

export const resolveFormalDefaultDueDateDays = (value?: unknown): number => {
  const n = Number(value);
  return n >= FORMAL_MIN_DUE_DAYS && n <= FORMAL_MAX_DUE_DAYS
    ? n
    : DEFAULT_FORMAL_DUE_DATE_DAYS;
};

export const resolveTeamDefaultDueDateDays = (value?: unknown): number =>
  resolveDueOption(value, DEFAULT_TEAM_DUE_DATE_DAYS);

export const resolveDisconnectDefaultDueDateDays = (value?: unknown): number =>
  resolveDueOption(value, DEFAULT_DISCONNECT_DUE_DATE_DAYS);

/** Prefill YYYY-MM-DD for Formal create / convert modals. */
export const buildDefaultFormalDueOn = (days?: unknown): string =>
  addUtcDaysToToday(resolveFormalDefaultDueDateDays(days));

/** Earliest / latest Formal due date (YYYY-MM-DD, UTC) for date inputs. */
export const formalDueMinInputValue = (): string =>
  addUtcDaysToToday(FORMAL_MIN_DUE_DAYS);

export const formalDueMaxInputValue = (): string =>
  addUtcDaysToToday(FORMAL_MAX_DUE_DAYS);
